import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftItemBrand,
  GiftItemBrandCreate,
  GiftItemBrandUpdate,
} from './giftItemBrand.interface';

// 생성
export const createGiftItemBrand = async (
  data: GiftItemBrandCreate,
  role: LowerRole,
): Promise<GiftItemBrand> => {
  const res = await api_.post(`/${role}/gift-item-brand`, data);
  return res.data;
};

// 수정
export const updateGiftItemBrand = async (
  id: string,
  data: GiftItemBrandUpdate,
  role: LowerRole,
): Promise<GiftItemBrand> => {
  const res = await api_.patch(`/${role}/gift-item-brand/${id}`, data);
  return res.data;
};

// 삭제
export const deleteGiftItemBrand = async (id: string, role: LowerRole): Promise<void> => {
  await api_.delete(`/${role}/gift-item-brand/${id}`);
};
